<script setup lang="ts">
import { CheckBadgeIcon } from '@heroicons/vue/24/solid'
</script>

<template>
    <div class="mt-1.5 mb-3">
        <div class="bg-cupra-white-off rounded p-4">
            <div class="flex gap-4 font-medium">
                <CheckBadgeIcon class="size-6 text-white" />
                Gelukt!
            </div>
            <p>
                <slot />
            </p>
        </div>
    </div>
</template>
